import type { DocumentRepository } from "../repositories/document-repository"

export const makeGetDocumentUes = (repo: DocumentRepository) =>
  (docId: string) => repo.getUes(docId)
